import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoreNavIconSecondary from './svgs/MoreNavIconSecondary.js';
import SvgMoreNavIcon from './svgs/MoreNavIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moreNavIcon = (props => useIcon(SvgMoreNavIcon, SvgMoreNavIconSecondary, props));

export { moreNavIcon as default };
